

import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../SanGameConfig";
import { SanCounter } from "./SanCounter";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { ScalableLayer } from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";

export class WinCounter extends BaseView {


    private static _normalCounter:SanCounter;
    public static get normalCounter():SanCounter{ return this._normalCounter; }

    constructor() { super(); }

    protected initAnimations():void{
        const layerToAdd:ScalableLayer = StageManager.getLayer(SanGameConfig.instance.LAYERS.WIN_COUNT_UP.name);
        WinCounter._normalCounter = layerToAdd.addChild(new SanCounter());
    }

    public onResize():void{
        WinCounter._normalCounter.onResize();
    }
}